import React, { memo } from 'react'

import { Icon, RotatingSpinner } from '@cgtrader/triangle-ui/dist/src/ssr-index'

const size = { width: '32px', height: '32px' }
const spinnerIcon = (
  <Icon svgComponent={RotatingSpinner} size={size} color="primary" notSpaced />
)

function LoadingState() {
  return <div className="image-uploader__loading">{spinnerIcon}</div>
}

export default memo(LoadingState)
